import { useState, useEffect } from 'react';

import { INTERVAL_ONE_SECOND } from '../../../constant/constants';
import Lottie from 'lottie-react';
import animation from '../../../assets/animation/MZKc7dDskN.json';
import { DateTime } from 'luxon';
import { useAppSelector } from '../../../hook/useAppSelector';

const DateAndTime: React.FC = () => {
  const selectedZone = useAppSelector((state) => state.configSlice.timeZone);

  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  useEffect(() => {
    const now = DateTime.now().setZone(selectedZone);
    setDate(now.toFormat('dd.MM.yyyy.'));
    setTime(now.toFormat('HH:mm:ss'));

    const interval = setInterval(() => {
      const now = DateTime.now().setZone(selectedZone);

      setDate(now.toFormat('dd.MM.yyyy.'));
      setTime(now.toFormat('HH:mm:ss'));
    }, INTERVAL_ONE_SECOND);

    return () => clearInterval(interval);
  }, [selectedZone]);

  return (
    <div>
      {date.length > 0 && time.length > 0 ? (
        <span className="date_time">
          {`${date}`}
          <strong> | </strong>
          {`${time}`}
        </span>
      ) : (
        <span className="date_time spinner">
          <Lottie
            animationData={animation}
            loop={true}
            autoPlay={true}
            style={{
              width: '17px',
              height: '17px',
              transformOrigin: 'center',
              transform: 'scale(3)',
              overflow: 'hidden',
            }}
          ></Lottie>
        </span>
      )}
    </div>
  );
};

export default DateAndTime;
